import * as types from './action-types';
import { defineAction } from 'store/common/action-helpers';

export const fetchAIPSkills = {
  start: () => defineAction(types.FETCH_AIP_SKILLS.START),
  success: payload => defineAction(types.FETCH_AIP_SKILLS.SUCCESS, payload),
  failure: payload => defineAction(types.FETCH_AIP_SKILLS.FAILURE, payload),
};
